import {useCallback, useEffect, useMemo, useState} from 'react'
import {Outlet, useNavigate} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {DrawerMessenger, ActivityDrawer, Main, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {useDispatch, useSelector} from 'react-redux'
import PageLoading from '../../app/routing/PageLoading'
import Comments from '../../app/pages/AdminPages/CommentDrawner/Comments'
import {Alert} from 'react-bootstrap'
import {KTSVG, timeZone} from '../helpers'
import {
  ContactClosePopup,
  ContactEndUpload,
  FirstTimeApprovalData,
  sessionClosePopup,
  sessionOpenPopup,
} from '../../app/Components/PopupSlice/popupSlice'
import {reset} from '../../app/Redux/store'
import {
  GetLastReport,
  UploadSuccessData,
} from '../../app/pages/UserPages/Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import RepotOfSubcriberUpload from '../../app/pages/UserPages/Contacts/AllContactsList/Modal/RepotOfSubcriberUpload'
import {getUserData, getUserOnboardingData} from '../../app/modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {fetchAsyncupdateProfileDetails} from '../../app/pages/UserPages/accounts/Overview/OverviewSlice/UpdateProfileSlice'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
  getIsDefaultRegion,
} from '../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import PageLoadingSend from '../../app/routing/PageLoadingSend'
import {useLazyGetDefaultCouponRateQuery, useLazyGetGroupQuery} from '../../services/cellcast'
import {useLazyGetGroupQuery as useLazyGetGroupQueryV3, useLazyGetLatestUploadHistoryQuery} from '../../services/cellcast.v3'
import {isLoading} from '../../app/Redux/FrontEnd/Loading/LoadingSlice'
import ModalSurvey from '../../app/pages/UserPages/Survey/Modal/ModalSurvey'
import {useGetActiveSystemAlertQuery} from '../../services/cellcast'
import moment from 'moment'
import { CouponRate } from '../../services/cellcast.type'
import { useCountdown } from '../../app/hooks/useCountdown'

const MasterLayout = () => {
  const calculateTimeLeft = (targetDate: number) => {
    const difference = targetDate - Date.now()
    const seconds = Math.max(0, Math.floor(difference / 1000) % 60)
    const minutes = Math.max(0, Math.floor(difference / 1000 / 60))
    return {minutes, seconds}
  }

  const navigate = useNavigate();
  const location = useLocation()
  const userValues = useSelector(getAllUserDetails)
  const dispatch = useDispatch()

  const isAdmin = localStorage.getItem('isAdmin')
  const loading = useSelector(isLoading)
  const loadingSend = useSelector((state: any) => state?.loadingSend)
  const sessionShowPopup = useSelector((state: any) => state.popup.sessionShowPopup)
  const contactStartUpload = useSelector((state: any) => state.popup.StartUploadPopup)
  const contactStopUpload = useSelector((state: any) => state.popup.contactUploadPopup)
  const firstTimeApproval = useSelector((state: any) => state.popup.firstTimeApproval)?.data

  const [getGroup, {data: getGroupData}] = useLazyGetGroupQuery()
  const [getGroupV3, {data: groupV3Data}] = useLazyGetGroupQueryV3()
  const [getLatestReport, {data: latestReport}] = useLazyGetLatestUploadHistoryQuery()
  const [fetchDefaultCouponRate] = useLazyGetDefaultCouponRateQuery()

  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const user = useSelector(getUserData)?.user?._id ?? null
  const data123 = useSelector((state: any) => state?.subscriberData?.Report?.data)
  const [successful, setSuccessful] = useState(false)
  const [targetDate, setTargetDate] = useState(Date.now() + 60 * 60 * 1000) // Set target date to 5 minutes from now
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate))
  const [firstTime, setFirstTime] = useState(true)


  const [defaultCouponRate, setDefaultCouponRate] = useState<CouponRate | null>(null)
  const expiredCoupon = useCountdown(defaultCouponRate?.expiredAt);

  const getGroupStatus = useCallback(() => {
    if (isDefaultRegion) {
      return getGroupData?.data?.status || ''
    }
    return groupV3Data?.data?.status || ''
  }, [getGroupData, groupV3Data, isDefaultRegion])

  // Fetch Group Status
  useEffect(() => {
    if (isDefaultRegion) {
      getGroup(null)
    } else {
      getGroupV3(null)
    }
  }, [contactStopUpload, getGroup, getGroupV3, isDefaultRegion])

  useEffect(() => {
    if (isDefaultRegion) {
      getGroup(null)
    } else {
      getGroupV3(null)
    }
  }, [isDefaultRegion])

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (!event?.storageArea?.token || !event?.storageArea?.permission) {
        dispatch(reset())
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [dispatch])

  useEffect(() => {
    if (!userValues?.hasUsedCoupon && !defaultCouponRate) {
      fetchDefaultCouponRate(null).then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          const coupons: CouponRate[] = res.data.data as unknown as CouponRate[];
          setDefaultCouponRate(coupons[coupons.length - 1])
        }
      })
    } else {
      setDefaultCouponRate(null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userValues?.hasUsedCoupon])

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    const resetInactivityTimer = () => {
      clearTimeout(timeoutId)
      if (!sessionShowPopup) {
        timeoutId = setTimeout(() => {
          dispatch(sessionOpenPopup())
          setFirstTime(true)
          setTargetDate(Date.now() + 60 * 60 * 1000)
          setTimeLeft(calculateTimeLeft(Date.now() + 60 * 60 * 1000))
        }, 180 * 60 * 1000) // 15 minutes in milliseconds
      }
    }

    const updateCountdown = () => {
      let tempTargetDate = targetDate
      let tempFirstTime = firstTime
      if (firstTime) {
        tempTargetDate = Date.now() + 60 * 60 * 1000
        setTargetDate(tempTargetDate)
        setFirstTime(false)
        tempFirstTime = false
      }
      if (sessionShowPopup && !tempFirstTime) {
        const newTimeLeft = calculateTimeLeft(tempTargetDate)
        setTimeLeft(newTimeLeft)
        if (newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
          dispatch(reset())
        }
      }
    }

    // Set up initial inactivity timer and countdown updater
    resetInactivityTimer()
    const countdownInterval = setInterval(updateCountdown, 1000)

    // Add event listeners for user interactions
    const handleInteraction = () => {
      dispatch(sessionClosePopup())
      resetInactivityTimer()
      setFirstTime(true)
    }

    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart']

    if (!sessionShowPopup) {
      events.forEach((event) => {
        document.addEventListener(event, handleInteraction)
        setTimeLeft(calculateTimeLeft(Date.now() + 60 * 60 * 1000))
      })
    }

    // window.addEventListener('scroll', handleInteraction)
    // window.addEventListener('keydown', handleInteraction)

    // Clear timers, intervals, and remove event listeners on component unmount
    return () => {
      clearTimeout(timeoutId)
      clearInterval(countdownInterval)
      events.forEach((event) => {
        document.removeEventListener(event, handleInteraction)
      })
      // window.removeEventListener('scroll', handleInteraction)
      // window.removeEventListener('keydown', handleInteraction)
    }
  }, [sessionShowPopup, targetDate])

  const handleActiveClick = () => {
    dispatch(sessionClosePopup())
    setTimeLeft(calculateTimeLeft(Date.now() + 60 * 60 * 1000))
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  const loadingComponent = useMemo(() => <PageLoading />, [loading])
  const loadingSendComponent = useMemo(
    () => <PageLoadingSend typeSend={loadingSend} />,
    [loadingSend]
  )

  const handleSummary = () => {
    if(isDefaultRegion){
      dispatch(GetLastReport())
    } else {
      getLatestReport(null)
    }
    dispatch(ContactEndUpload())
    getGroup(null)
    setSuccessful(true)
  }

  const handleCloseBanner = async () => {
    let time =
      (await timeZone?.find((key: any) => key?.value === userValues.timeZone)?.utc[0]) ||
      userValues.timeZone
    const formData = new FormData()
    formData.append('companyName', userValues?.companyName)
    formData.append('email', userValues?.email)
    formData.append('companyWebsite', userValues?.companyWebsite)
    formData.append('industry', userValues?.industry)
    formData.append('designation', 'Developer')
    formData.append('gender', 'Male')
    formData.append('language', userValues?.language)
    formData.append('firstName', userValues?.firstName)
    formData.append('lastName', userValues?.lastName)
    formData.append('timeZone', time)
    formData.append('currency', userValues?.currency)
    formData.append('emailCommunication', userValues?.communication.email)
    formData.append('phoneCommunication', userValues?.communication.phone)
    formData.append('rmsChatDomain', userValues?.rmsChatDomain)

    formData.append('country', userValues?.country)
    formData.append('avatar', userValues?.avatar)
    formData.append('isReadFirstMessageApproval', 'true')
    dispatch(fetchAsyncupdateProfileDetails(formData)).then(() => {
      if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
      dispatch(fetchAsyncUserDetails())
    })
  }

  const getUserGroups = () => {
    if (isDefaultRegion) {
      return getGroupData && getGroupData?.data?.status !== 'Completed'
    } else {
    }
  }

  const onboarding = useSelector(getUserOnboardingData);
  useEffect(() => {
    if (onboarding.isComplete && onboarding.isFinished && location.pathname.startsWith('/onboarding')) {
      navigate('/dashboard');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {data: systemAlertData} = useGetActiveSystemAlertQuery({
    startAt: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    endAt: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  })
  const systemAlert = systemAlertData?.data

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          {isAdmin !== 'true' &&
            systemAlert && systemAlert?.methods?.includes('banner') && (
              <div className='d-flex justify-content-center m-5 mb-0'>
                <Alert
                  variant={
                    systemAlert.type === 'info'
                      ? 'info'
                      : systemAlert.type === 'warning'
                      ? 'warning'
                      : systemAlert.type === 'danger' || systemAlert.type === 'alert'
                      ? 'danger'
                      : 'primary'
                  }
                  className='py-1 px-2 w-100 alert-message m-0'
                >
                  <div className='d-flex justify-content-center align-items-center'>
                    <KTSVG
                      path={
                        systemAlert.type === 'info'
                          ? '/media/icons/duotune/general/gen044.svg'
                          : systemAlert.type === 'warning'
                          ? '/media/icons/duotune/general/gen044.svg'
                          : '/media/icons/duotune/general/gen042.svg'
                      }
                      className={`svg-icon-3x svg-icon-${
                        systemAlert.type === 'info'
                          ? 'info'
                          : systemAlert.type === 'warning'
                          ? 'warning'
                          : 'danger'
                      } me-4`}
                    />
                    <div className='col' style={{padding: '8px 0px'}}>
                      <h4 className='m-0' style={{fontSize: 18}}>
                        {systemAlert.title}
                      </h4>
                      <p className='m-0'>
                        <span dangerouslySetInnerHTML={{__html: systemAlert.message}} />
                      </p>
                    </div>
                  </div>
                </Alert>
              </div>
            )}

          {sessionShowPopup && (
            <div className='d-flex justify-content-center m-5'>
              <Alert variant={'warning'} className='w-100 alert-message '>
                <KTSVG
                  path='/media/icons/duotune/general/gen044.svg'
                  className='svg-icon-2x svg-icon-warning me-4'
                />
                We've noticed that you've been inactive for a while. For security, your session will
                time out in &nbsp;&nbsp;{timeLeft.minutes}:
                {timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds} minutes
                &nbsp;&nbsp;
                <Alert.Link
                  href='#'
                  onClick={() => {
                    handleActiveClick()
                  }}
                  className='text-primary'
                >
                  Continue session
                </Alert.Link>
              </Alert>
            </div>
          )}
          {!!firstTimeApproval?.messageUnderApproval ? (
            <div className='d-flex justify-content-center m-5 mb-0'>
              <Alert variant={'warning'} className='py-1 px-2 w-100 alert-message m-0'>
                <div className='d-flex justify-content-center align-items-center'>
                  <KTSVG
                    path='/media/icons/duotune/navigationicon/bulkmsg.svg'
                    className='svg-icon-3x svg-icon-warning me-4'
                  />
                  <div
                    className='col'
                    style={{
                      padding: '8px 0px',
                    }}
                  >
                    <h2
                      className='m-0'
                      style={{
                        fontSize: '18px !important',
                      }}
                    >
                      Your message is going through a security check.
                    </h2>
                    <p className='m-0'>
                      This may cause a small delay in sending. Please call if your message is urgent
                      and we can expedite the process.
                    </p>
                  </div>
                </div>
              </Alert>
            </div>
          ) : null}
          {!firstTimeApproval?.messageUnderApproval &&
          !firstTimeApproval?.isReadFirstMessageApproval &&
          (firstTimeApproval?.smsStatus == 'approved' ||
            firstTimeApproval?.smsStatus == 'testing') ? (
            <div className='d-flex justify-content-center  m-5 mb-0'>
              <Alert variant={'success'} className='py-1 px-2 w-100 alert-message mb-0'>
                <div className='d-flex justify-content-center align-items-center me-4'>
                  <KTSVG
                    path='/media/icons/duotune/navigationicon/bulkmsg.svg'
                    className='svg-icon-3x svg-icon-success me-4'
                  />
                  <div
                    className='col'
                    style={{
                      padding: '8px 0px',
                    }}
                  >
                    <h2
                      className='m-0'
                      style={{
                        fontSize: '18px !important',
                      }}
                    >
                      Your message has been approved.
                    </h2>
                    <p className='m-0'>
                      Your message/s have been approved to send by our security team. You can view
                      send results via the report.{' '}
                    </p>
                  </div>
                  <button
                    className='btn btn-custom btn-success  py-2 message-btn'
                    onClick={handleCloseBanner}
                  >
                    Close
                  </button>
                </div>
              </Alert>
            </div>
          ) : null}
          {!firstTimeApproval?.messageUnderApproval &&
          !firstTimeApproval?.isReadFirstMessageApproval &&
          firstTimeApproval?.smsStatus == 'rejected' ? (
            <div className='d-flex justify-content-center  m-5 mb-0'>
              <Alert variant={'danger'} className='py-1 px-2 w-100 alert-message mb-0'>
                <div className='d-flex justify-content-center align-items-center me-4'>
                  <KTSVG
                    path='/media/icons/duotune/navigationicon/bulkmsg.svg'
                    className='svg-icon-3x svg-icon-danger me-4'
                  />
                  <div
                    className='col'
                    style={{
                      padding: '8px 0px',
                    }}
                  >
                    <h2
                      className='m-0'
                      style={{
                        fontSize: '18px !important',
                      }}
                    >
                      Your message has been rejected.
                    </h2>
                    <p className='m-0'>
                      Your message/s have been rejected to send by our security team, for more
                      information you can email us at support@cellcast.com.au
                    </p>
                  </div>
                  <button
                    className='btn btn-custom btn-danger  py-2 message-btn'
                    onClick={handleCloseBanner}
                  >
                    Close
                  </button>
                </div>
              </Alert>
            </div>
          ) : null}
          {contactStartUpload && (
            <div className='d-flex justify-content-center  m-5 mb-0'>
              <Alert variant={'success'} className='py-1 px-2 w-100 alert-message mb-0'>
                <div className='d-flex justify-content-center align-items-center me-4'>
                  <KTSVG
                    path='/media/icons/duotune/communication/com005.svg'
                    className='svg-icon-3x svg-icon-success me-4'
                  />
                  <div
                    className='col'
                    style={{
                      padding: '8px 0px',
                    }}
                  >
                    <h2
                      className='m-0'
                      style={{
                        fontSize: '18px !important',
                      }}
                    >
                      Contacts uploaded!
                    </h2>
                    <p className='m-0'>You can view you summary and download any error reports</p>
                  </div>
                  <button
                    className='btn btn-custom btn-success  py-2 message-btn'
                    onClick={handleSummary}
                  >
                    View summary
                  </button>
                </div>
              </Alert>
            </div>
          )}

          {getGroupStatus() !== 'Completed' && contactStopUpload && (
            <div className='d-flex justify-content-center m-5 mb-0'>
              <Alert variant={'warning'} className='py-1 px-2 w-100 alert-message m-0'>
                <div className='d-flex justify-content-center align-items-center'>
                  <KTSVG
                    path='/media/icons/duotune/communication/com005.svg'
                    className='svg-icon-3x svg-icon-warning me-4'
                  />
                  <div
                    className='col'
                    style={{
                      padding: '8px 0px',
                    }}
                  >
                    <h2
                      className='m-0'
                      style={{
                        fontSize: '18px !important',
                      }}
                    >
                      Your contacts are being uploaded...
                    </h2>
                    <p className='m-0'>
                      Your contacts are being uploaded in the background you do not need to stick
                      around we will let you know when all your contacts have been uploaded
                      successfully
                    </p>
                  </div>
                </div>
              </Alert>
            </div>
          )}

          {defaultCouponRate && !userValues?.hasUsedCoupon ? (
            <div className='d-flex justify-content-center  m-5 mb-0'>
              <Alert variant={'success'} className='py-1 px-4 w-100 alert-message mb-0'>
                <div className="d-flex justify-content-between me-4 w-100">
                  {/* Left icon */}
                  <div className='d-flex align-items-center me-4'>
                    <div className="d-flex align-items-center">
                      <KTSVG
                        path="/media/icons/duotune/navigationicon/cash.svg"
                        className="svg-icon-3x svg-icon-success me-4"
                      />
                    </div>

                    {/* Description (60%) */}
                    <div
                      className="d-flex flex-column justify-content-center"
                      style={{
                        width: '60%',
                        padding: '8px 0',
                      }}
                    >
                      <h2
                        className="m-0"
                        style={{
                          fontSize: '18px',
                        }}
                      >
                        Coupon Applied
                      </h2>
                      <p className="m-0">
                        Your coupon code <b>{defaultCouponRate?.code}</b> from {defaultCouponRate?.staffName} has been applied to your account. 
                        The coupon will be automatically applied at checkout with a minimum purchase of {defaultCouponRate?.min_credit} credits.
                      </p>
                    </div>
                  </div>

                  {/* Right side - expired + button */}
                  <div className="d-flex align-items-center gap-3">
                    <div className="fw-boldest" style={{ whiteSpace: 'nowrap' }}>{expiredCoupon}</div>
                    <button
                      className="btn btn-custom btn-success py-2 message-btn"
                      style={{ whiteSpace: 'nowrap' }}
                      onClick={() => navigate('/topup')}
                    >
                      Purchase Now
                    </button>
                  </div>
                </div>
              </Alert>
            </div>
          ) : null}
          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='bg-danger'></div>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
                {loading && loadingComponent}
                {loadingSend.length > 0 && loadingSendComponent}
              </Content>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
      {/* <SessionLogout /> */}
      
      <ModalSurvey />
      <RepotOfSubcriberUpload
        ReportData={isDefaultRegion ? data123 : latestReport?.data}
        show={successful}
        handleClose={() => setSuccessful(false)}
      />

      {/* begin:: Drawers */}
      <ActivityDrawer />
      <RightToolbar />
      {/* <Comments/> */}
      {/* meetpls */}
      {/* <DrawerMessenger /> */}
      <Comments />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <Main />
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
